import { Injectable } from '@angular/core';
import { Categories } from '../business-entities/category-list-model';
import { GenericResponse } from '../business-entities/generic-response';
import { CategoryDataService } from '../data-services/category-data.service';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {
  constructor(private service: CategoryDataService) {
  }
  categoryId: number
  categoryList: Categories[];
  category: Categories;
  async getCategoryList(vehicalObj: any): Promise<Categories[]> {
    await this.service
      .getCategoryList(vehicalObj)
      .then(
        (res: GenericResponse<Array<Categories>>) => {
          this.categoryList = res.responseObject;
        }
      );
    return this.categoryList;
  }
  deleteCategory(id: number): Promise<any> {
    return this.service.deleteCategory(id);
  }

  activeInactiveCategory(vehicalObj: any): Promise<any> {
    return this.service.activeInactiveCategory(vehicalObj);
  }

  async getCategoryById(categoryId: number) {
    return this.service.getCategoryById(categoryId);
  }

  async addEditCategory(model: any): Promise<any> {
    return this.service.addEditCategory(model);
  }
}
